import React, { useMemo, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Brand } from './Brand.jsx';

export function Lobby({ state, busy, onAction, onLeave }) {
  const viewer = state.players.find((player) => player.id === state.viewer.id);
  const [copied, setCopied] = useState(false);
  const inviteUrl = useMemo(() => `${window.location.origin}${window.location.pathname}?room=${state.code}`, [state.code]);
  const unready = state.players.filter((player) => !player.isBot && !player.ready && player.id !== state.hostId);

  async function share() {
    const data = { title: 'RowSprint', text: `Komm in meinen RowSprint-Raum ${state.code}`, url: inviteUrl };
    if (navigator.share) {
      await navigator.share(data).catch(() => {});
    } else {
      await navigator.clipboard.writeText(inviteUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    }
  }

  return (
    <main className="app-shell lobby-shell">
      <header className="topbar">
        <Brand compact />
        <button className="button button--ghost button--small" onClick={onLeave}>Verlassen</button>
      </header>

      <div className="lobby-grid">
        <section className="panel invite-panel">
          <span className="eyebrow">Privater Raum</span>
          <h1>{state.code}</h1>
          <p>Teile den Code oder scanne den QR-Code. Der Link öffnet die Lobby direkt.</p>
          <div className="qr-wrap"><QRCodeSVG value={inviteUrl} size={188} level="M" marginSize={2} /></div>
          <button className="button button--primary" onClick={share}>{copied ? 'Link kopiert' : 'Einladung teilen'}</button>
          <code>{inviteUrl}</code>
        </section>

        <section className="panel players-panel">
          <div className="panel-heading">
            <div><span className="eyebrow">Lobby</span><h2>Spieler {state.players.length}/{state.settings.maxPlayers}</h2></div>
            {state.spectators.length > 0 && <span className="tag">{state.spectators.length} Zuschauer</span>}
          </div>
          <div className="lobby-players">
            {state.players.map((player) => (
              <article className="lobby-player" key={player.id}>
                <span className="avatar">{player.isBot ? '🤖' : player.name.slice(0, 1).toUpperCase()}</span>
                <div><strong>{player.name}{player.id === state.viewer.id ? ' (du)' : ''}</strong><small>{player.id === state.hostId ? 'Host' : player.isBot ? 'Computergegner' : player.ready ? 'Bereit' : 'Noch nicht bereit'}</small></div>
                <span className={`ready-dot ${player.ready || player.id === state.hostId ? 'is-ready' : ''}`} />
                {!player.isBot && ((state.viewer.isHost || player.id === state.viewer.id) ? (
                  <button
                    className={`child-mode-toggle ${player.childMode ? 'is-active' : ''}`}
                    title={`Kindermodus für ${player.name} ${player.childMode ? 'deaktivieren' : 'aktivieren'}`}
                    aria-pressed={player.childMode}
                    onClick={() => onAction('lobby:childMode', { playerId: player.id, enabled: !player.childMode })}
                  >
                    <span aria-hidden="true">🧒</span> Hilfe
                  </button>
                ) : player.childMode ? <span className="child-mode-badge" title="Kindermodus aktiv">🧒 Hilfe</span> : null)}
                {state.viewer.isHost && player.id !== state.viewer.id && (
                  <button className="icon-button" title="Entfernen" onClick={() => onAction('lobby:removePlayer', { playerId: player.id })}>×</button>
                )}
              </article>
            ))}
          </div>

          {state.viewer.role === 'player' && (
            <button className={`button ${viewer?.ready ? 'button--ghost' : 'button--secondary'}`} disabled={busy} onClick={() => onAction('lobby:ready', { ready: !viewer?.ready })}>
              {viewer?.ready ? 'Nicht mehr bereit' : 'Ich bin bereit'}
            </button>
          )}

          {state.viewer.isHost && (
            <div className="host-actions">
              <button className="button button--ghost" disabled={state.players.length >= state.settings.maxPlayers || busy} onClick={() => onAction('lobby:addBot', {})}>+ Bot hinzufügen</button>
              <button className="button button--primary button--large" disabled={state.players.length < 2 || unready.length > 0 || busy} onClick={() => onAction('game:start')}>
                Spiel starten
              </button>
              {unready.length > 0 && <small>Warte auf: {unready.map((player) => player.name).join(', ')}</small>}
            </div>
          )}
        </section>

        {state.viewer.isHost && (
          <section className="panel settings-panel">
            <div className="panel-heading"><div><span className="eyebrow">Host</span><h2>Raumeinstellungen</h2></div></div>
            <label className="setting-row"><span>Maximale Spieler</span><select value={state.settings.maxPlayers} onChange={(event) => onAction('lobby:settings', { ...state.settings, maxPlayers: Number(event.target.value) })}>{[2,3,4,5].map((value) => <option key={value}>{value}</option>)}</select></label>
            <label className="setting-row"><span>Zugzeit</span><select value={state.settings.turnTimerSeconds} onChange={(event) => onAction('lobby:settings', { ...state.settings, turnTimerSeconds: Number(event.target.value) })}><option value={0}>Unbegrenzt</option>{[30,45,60,90,120].map((value) => <option key={value} value={value}>{value} Sekunden</option>)}</select></label>
            <label className="setting-row"><span>Zuschauer erlauben</span><input type="checkbox" checked={state.settings.allowSpectators} onChange={(event) => onAction('lobby:settings', { ...state.settings, allowSpectators: event.target.checked })} /></label>
          </section>
        )}
      </div>
    </main>
  );
}
